// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_page{
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
}

.login_page_left, .login_page_right{
    max-width: calc(100%/2);
    width: 100%;
}
.login_page_left{
    height: 100%;
    overflow: hidden;
    position: relative;
    z-index: 1;
}
.login_page_left:before{
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(5,113,185,0.7);
}
.login_page_left img{
    height: 100%;
    object-fit: cover;
    width: 100%;
    mix-blend-mode: multiply;
}

.login_page_right{
    padding: 0 80px;
}

.login_inner_logo{
    text-align: center;
}

.login_inner_bottom{
    width: 100%;
    padding: 20px;
    border-radius: 10px;
    background: #0571b9;
    margin-top: 30px;
    box-shadow: 0 0 10px rgba(0,0,0,0.4);
}

.login_field{
    height: 50px;
    border: 0px;
    border-radius: 6px;
    background: #fff;
    box-shadow: 0 0 5px rgba(0,0,0,0.3);
}
.login_field::placeholder{
    color: #000;
}
.login_inner_bottom label{
    color: #fff;
    font-size: 16px;
    font-weight: 500;
}

.forgot_pass{
    margin-top: 14px;
}

.forgot_pass a{
    display: flex;
    justify-content: flex-end;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    text-decoration: underline;
}

.login_submit{
    margin-top: 30px;
    display: flex;
    justify-content: center;
}

.login_submit .sub_log_but{
    height: 40px;
    line-height: 40px;
    padding: 0 60px;
    color: #fff;
    border: 0px;
    background: rgb(36, 57, 119);
    border-radius: 10px;
    box-shadow: 0 0 30px rgba(36, 57, 119, 0.65);
}

.trip_text{
    font-size: 26px;
    color: #000;
    font-weight: 600;
    line-height: 32px;
    text-align: center;
    text-shadow: 0 0 10px rgba(0,0,0,0.5);
    border-radius: 7px;
}

.login_page_left .trip_text{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    padding: 10px 20px;
}

.trip_text_holder{
    text-align: center;
}
.max-100{
    max-width: 100%;
}
@media screen and (max-width:1199px){
    .login_page_right{
        padding: 0 20px;
    }
}

@media screen and (max-width:767px){
    .login_page{
        flex-wrap: wrap;
        height: 100%;
    }
    .login_page_left, .login_page_right{
        max-width: 100%;
    }

    .login_page_right{
        margin-top: 30px;
    }

    .login_inner_logo img{
        max-width: 100%;
        height: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/logout/logout.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,WAAW;AACf;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,+BAA+B;AACnC;AACA;IACI,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,mCAAmC;AACvC;AACA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,WAAW;IACX,4BAA4B;IAC5B,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;AACA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,YAAY;IAChB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;AACJ","sourcesContent":[".login_page{\n    width: 100%;\n    height: 100vh;\n    display: flex;\n    align-items: center;\n}\n\n.login_page_left, .login_page_right{\n    max-width: calc(100%/2);\n    width: 100%;\n}\n.login_page_left{\n    height: 100%;\n    overflow: hidden;\n    position: relative;\n    z-index: 1;\n}\n.login_page_left:before{\n    content: \"\";\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background: rgba(5,113,185,0.7);\n}\n.login_page_left img{\n    height: 100%;\n    object-fit: cover;\n    width: 100%;\n    mix-blend-mode: multiply;\n}\n\n.login_page_right{\n    padding: 0 80px;\n}\n\n.login_inner_logo{\n    text-align: center;\n}\n\n.login_inner_bottom{\n    width: 100%;\n    padding: 20px;\n    border-radius: 10px;\n    background: #0571b9;\n    margin-top: 30px;\n    box-shadow: 0 0 10px rgba(0,0,0,0.4);\n}\n\n.login_field{\n    height: 50px;\n    border: 0px;\n    border-radius: 6px;\n    background: #fff;\n    box-shadow: 0 0 5px rgba(0,0,0,0.3);\n}\n.login_field::placeholder{\n    color: #000;\n}\n.login_inner_bottom label{\n    color: #fff;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.forgot_pass{\n    margin-top: 14px;\n}\n\n.forgot_pass a{\n    display: flex;\n    justify-content: flex-end;\n    color: #fff;\n    font-size: 16px;\n    font-weight: 500;\n    text-decoration: underline;\n}\n\n.login_submit{\n    margin-top: 30px;\n    display: flex;\n    justify-content: center;\n}\n\n.login_submit .sub_log_but{\n    height: 40px;\n    line-height: 40px;\n    padding: 0 60px;\n    color: #fff;\n    border: 0px;\n    background: rgb(36, 57, 119);\n    border-radius: 10px;\n    box-shadow: 0 0 30px rgba(36, 57, 119, 0.65);\n}\n\n.trip_text{\n    font-size: 26px;\n    color: #000;\n    font-weight: 600;\n    line-height: 32px;\n    text-align: center;\n    text-shadow: 0 0 10px rgba(0,0,0,0.5);\n    border-radius: 7px;\n}\n\n.login_page_left .trip_text{\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: #fff;\n    padding: 10px 20px;\n}\n\n.trip_text_holder{\n    text-align: center;\n}\n.max-100{\n    max-width: 100%;\n}\n@media screen and (max-width:1199px){\n    .login_page_right{\n        padding: 0 20px;\n    }\n}\n\n@media screen and (max-width:767px){\n    .login_page{\n        flex-wrap: wrap;\n        height: 100%;\n    }\n    .login_page_left, .login_page_right{\n        max-width: 100%;\n    }\n\n    .login_page_right{\n        margin-top: 30px;\n    }\n\n    .login_inner_logo img{\n        max-width: 100%;\n        height: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
